import React from 'react';
import Locale from '../../domain/Locale';
import Amount from '../../domain/Amount';
import User from '../../domain/User';
import get_bundle from '../../domain/get_bundle';
import Color from '../../domain/Color';
import isEmpty from '../../domain/isEmpty';
import Table from '../Table';
import DefaultUi from '../DefaultUi';
import sortByOrder from 'lodash/collection/sortByOrder';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  purchases: t.Obj,
  user: User,
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  goPurchase: t.Func,
  goAccount: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.Func
})
export default class Purchases extends React.Component {


  onClick(id, evt) {
    evt.preventDefault();
    this.props.goPurchase(id);
  }

  hasRows() {
    return (this.props.purchases && !(isEmpty(this.props.purchases)));
  }

  getRow(bundle, purchase) {
    return (
      <tr key={purchase.id}>
        <td><a onClick={this.onClick.bind(this, purchase.id)} href='#'>{purchase.product}</a></td>
        <td>{Amount.format(this.props.locale, purchase.currency, purchase.amount)}</td>
        <td>{bundle.status[purchase.status]}</td>
      </tr>
    );
  }

  getRowsTable(bundle) {
    return sortByOrder(this.props.purchases, 'tick', 'desc').map((purchase) => {return this.getRow(bundle, purchase);});
  }

  getContentHTML(rows, bundle) {
    const striped = true;
    if (this.hasRows()) {
      return (
        <Table columns={bundle.table} striped={striped}>
          { rows }
        </Table>
      );
    }
    else {
      return <em>{ bundle.no_purchases }</em>;
    }
  }

  render() {

    const { locale } = this.props;
    const bundle = get_bundle(locale).purchases;
    const rows = this.getRowsTable(bundle);

    return (
      <DefaultUi id="purchases" title={bundle.title} themeBgColor={this.props.themeBgColor} themeBgFontColor={this.props.themeBgFontColor}>
        <div className="cols">
          <div className="large-100">
            <div className="cell">
              { this.getContentHTML(rows, bundle) }
            </div>
          </div>
        </div>
      </DefaultUi>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/content/Purchases.js
 **/